import {
  Component,
  OnInit,
  Input,
  AfterViewInit,
  Inject,
  HostListener,
  OnDestroy,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DateManagerService } from 'src/app/shared/services/date-manager/date-manager.service';
import { TransactionsService } from '../../../core/functions/transactions.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'makaw-barchart',
  templateUrl: './barchart.component.html',
  styleUrls: ['./barchart.component.scss'],
})
export class BarchartComponent implements OnInit, OnDestroy {
  @Input() transaction$: Observable<any[]>;
  private destroyed$ = new Subject();
  public transactions;

  private dates: any[];
  public amounts = [
    { data: [], label: 'Expenses' },
    { data: [], label: 'Incomes' },
  ];
  public chartReady = false;
  public barChartOptions = {
    scaleShowVerticalLines: false,
    responsive: true,
  };

  public barChartType = 'bar';
  public barChartLegend = true;

  constructor(
    private dateManagerService: DateManagerService,
    private transactionService: TransactionsService
  ) {}

  ngOnInit() {
    this.transaction$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((transactions) => {
        this.transactions = transactions;
        this.paintByDay();
      });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  paintByYear() {
    this.paintGraph(this.dateManagerService.datesFormaterByYear);
  }
  paintByMonth() {
    this.paintGraph(this.dateManagerService.datesFomraterByMonth);
  }
  paintByDay() {
    this.paintGraph(this.dateManagerService.datesFormaterByDay);
  }

  paintGraph(dateFormater) {
    this.dates = this.transactionService.groupAndFormatByDates(
      dateFormater,
      this.transactions
    );

    const transactionsFormated = this.transactionService.transactionsDateFormater(
      dateFormater,
      this.transactions
    );

    this.amounts[0].data = this.transactionService.calculateExpensesGroupedByDates(
      this.dates,
      transactionsFormated
    );

    this.amounts[1].data = this.transactionService.calculateIncomesGroupedByDates(
      this.dates,
      transactionsFormated
    );

    this.chartReady = true;
  }
}
